<template>
  <div>
    <!-- <v-container> -->
      <v-row>
        <!-- {{ data.items }} -->
        <v-col v-for="(item) in data.items" :key="item.id" cols="12" sm="6" lg="4" class="px-1">
          <v-card  elevation="0" outlined>
            <v-card-title>
              <v-icon medium left>mdi-file-upload-outline</v-icon>
                <span class="text-body-2 font-weight-bold text--secondary" >{{ item.filename }}</span>
              </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-list>
                <v-list-item>
                  <v-row>
                    <v-col cols="5">
                      <span class="font-weight-bold mr-12 text-caption">Date </span>
                    </v-col>
                    <v-col>
                      <v-icon small class="mr-2">mdi-calendar</v-icon>
                      <span class="text-caption">{{ item.date }}</span>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider></v-divider>
                <!-- <v-list-item >
                  <v-row>
                    <v-col cols="5">
                      <span class="font-weight-bold mr-12">Type </span>
                    </v-col>
                    <v-col>
                      <v-icon small class="mr-2">mdi-file-document</v-icon>
                      <span class="text-caption">{{ item.type }}</span> 
                    </v-col>
                  </v-row>
                </v-list-item> -->
                <!-- <v-divider></v-divider> -->
                <v-list-item>
                  <v-row>
                    <v-col cols="5">
                      <span class="font-weight-bold mr-12 text-caption">Processed</span>
                    </v-col>
                    <v-col>
                      <!-- <v-icon small class="mr-2">mdi-check-circle</v-icon> -->
                    <span class="text-caption">
                      {{ item.processed }}
                    </span>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-row>
                    <v-col cols="5">
                      <span class="font-weight-bold mr-12 text-caption">Added</span>
                    </v-col>
                    <v-col>
                    <span class="text-caption">
                      {{ item.added }}
                    </span>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-row>
                    <v-col cols="5">
                      <span class="font-weight-bold mr-12 text-caption">Errors </span>
                    </v-col>
                    <v-col>
                    <!-- <v-icon small class="mr-2">mdi-alert-circle</v-icon> -->
                    <span class="text-caption">
                      {{ item.errors }}
                    </span>
                    </v-col>
                  </v-row>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-row>
                    <v-col cols="5">
                      <span class="font-weight-bold mr-12 text-caption">Status </span>
                    </v-col>
                    <v-col>
                      <v-icon small class="mr-2" color="success" v-if="item.status === 'done'">mdi-check-circle</v-icon>
                      <v-icon small class="mr-2" color="warning" v-if="item.status === 'uncompleted'">mdi-alert-circle</v-icon>
                      <v-icon small class="mr-2" color="error" v-if="item.status === 'error'">mdi-close-circle</v-icon>
                      {{ item.status }}
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card-text>  
          </v-card>
        </v-col>
      </v-row>
    <!-- </v-container> -->
    
    <v-data-table
      hidden
      :headers="headers"
      :items="data.items"
      :options.sync="pagination"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
      :server-items-length="data.count"
      :loading="loading"
      :items-per-page="10"
    >
      <template v-slot:item.status="{ item }">
        <v-tooltip
          bottom
          :disabled="
            item.status != 'uncompleted' &&
            item.status != 'suspending' &&
            item.status != 'error'
          "
        >
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <badge
                :text="item.status == 'done' ? 'success' : item.status"
                :color="badgeColor(item.status)"
                :progress="
                  item.status == 'pending' || item.status == 'processing'
                "
                cursor="help"
              />
            </span>
          </template>
          <span>{{ item.msg }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.errors="{ item }">
        <v-tooltip bottom :disabled="item.status != 'uncompleted'">
          <template v-slot:activator="{ on }">
            <span v-on="on" @click="handleErrors(item)">
              <badge
                :text="item.errors"
                :color="item.errors > 0 ? 'red' : 'grey'"
                small="true"
                cursor="pointer"
              />
            </span>
          </template>
          <span>Click to handle Errors</span>
        </v-tooltip>
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip
          bottom
          v-if="item.status != 'uncompleted' && item.type_num != '2'"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              @click="downloadFile(false, item.id)"
              v-on="on"
              icon
              small
              :disabled="item.status == 'pending'"
            >
              <v-icon> mdi-download </v-icon>
            </v-btn>
          </template>
          <span>Download Origin</span>
        </v-tooltip>

        <v-menu
          open-on-hover
          bottom
          offset-y
          v-if="item.status == 'uncompleted' && item.type_num != '2'"
        >
          <template v-slot:activator="{ on: menu }">
            <v-btn class="action-icon" v-on="{ ...menu }" small icon>
              <v-icon> mdi-download </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="downloadFile(false, item.id)">
              <v-list-item-title>Download Origin</v-list-item-title>
            </v-list-item>
            <v-list-item @click="downloadFile(true, item.id)">
              <v-list-item-title>Download Errors</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="confirmModal(item)"
              v-on="on"
              icon
              small
              :class="item.status == 'suspending' ? 'display' : 'hide'"
            >
              <v-icon> mdi-alert-box </v-icon>
            </v-btn>
          </template>
          <span>Confirm Insertion</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      data: [],
      loading: false,
      pagination: { totalItems: 0,itemsPerPage:6 },
      headers: [
        { text: "Importations", value: "filename", sortable: false },
        { text: "Date", value: "date", align: "center", sortable: false },
        { text: "Type", value: "type", align: "center", sortable: false },
        {
          text: "Processed",
          value: "processed",
          align: "center",
          sortable: false,
          width: "1%",
        },
        {
          text: "Added",
          value: "added",
          align: "center",
          sortable: false,
          width: "1%",
        },
        {
          text: "Errors",
          value: "errors",
          align: "center",
          sortable: false,
          width: "1%",
        },
        {
          text: "Status",
          value: "status",
          align: "center",
          sortable: false,
          width: "1%",
        },
        { text: "Actions", value: "action", align: "center", sortable: false },
      ],
    };
  },
  props: ["importations"],
  components: {},
  mounted() {
    this.data = this.importations;
    this.$socket.client.on("globalListener", (data) => {
      if (data.dataChanged && data.cause == "importationChanges") {
        this.getRequests();
      }
    });
  },
  methods: {
    badgeColor(status) {
      let color = "success";
      switch (status) {
        case "pending":
          color = "secondary";
          break;
        case "processing":
          color = "secondary";
          break;
        case "error":
          color = "red";
          break;
        case "done":
          color = "green";
          break;
        case "suspending":
          color = "grey";
          break;
        case "uncompleted":
          color = "orange";
          break;
      }
      return color;
    },
    confirmModal(item) {
      this.$emit("confirm-modal-event", item);
    },
    handleErrors(payload) {
      if (payload.status == "uncompleted")
        this.$emit("show-handle-error-modal", payload);
    },
    blobToFile(data, filename) {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    downloadFile(error, id) {
      axios
        .get("/api/importation/getfile", {
          params: {
            account_id: localStorage.getItem("account_id"),
            id,
            error,
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
          responseType: "blob",
        })
        .then((res) => {
          let filename = res.headers.filename;
          this.blobToFile(res.data, filename);
        })
        .catch(function () {
          console.log("FAILURE!! get all requests");
        });
    },
    getRequests() {
      this.loading = true;
      let from =
        this.pagination.page * this.pagination.itemsPerPage -
        this.pagination.itemsPerPage;
      let size = this.pagination.itemsPerPage;

      axios
        .get("/api/importation", {
          params: {
            account_id: localStorage.getItem("account_id"),
            from,
            size,
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.$emit("update-statistics", {});
          this.data = res.data;
          this.loading = false;
          this.$forceUpdate();
        })
        .catch(function () {
          console.log("FAILURE!! get all requests");
        });
    },
  },
  watch: {
    pagination: {
      handler() {
        try {
          this.getRequests();
        } catch (error) {
          console.log("pagination", error);
        }
      },
      deep: true,
    },
    importations: {
      deep: true,
      handler() {
        this.pagination.page = 1;
        this.data = this.importations;
      },
    },
  },
};
</script>
<style>

.action-icon {
  font-size: 24px !important;
}
.pending-badge,
.processing-badge {
  background-color: #bed9f3 !important;
  color: #0477ea;
}
.error-badge {
  background-color: #fceaed;
  color: #bc3343;
  cursor: help;
}
.done-badge {
  background-color: #effae8;
  color: #63ac75;
  /* background-color: #51a951 !important; */
}
.suspending-badge {
  background-color: #e4e4e4 !important;
  color: #717171;
  cursor: help;
}
.uncompleted-badge {
  background-color: #f9ede3 !important;
  color: #ff7001;
  cursor: help;
}
.error-color {
  color: #bc3343;
}
.error_msg {
  color: #bc3343;
}
.display {
  display: inline-flex !important;
}
.hide {
  display: none !important;
}
</style>
